import React, { Component } from 'react';
import { ROLES, withRoles } from '../Permissions';

import AddedReviewers from './AddedReviewers';
import AddCanvasUsers from './AddCanvasUsers';
import {withStyles} from "@material-ui/core/styles/index";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const styles = {
    card: {
        minWidth: 275,
        marginBottom: 15
    },
    headertitle: {
        fontSize: 'x-large',
        color: '#000',
        backgroundColor: '#fff',
        padding: 16,
        marginBottom: -25
    }

};

class ManageReviewers extends Component {
  render () {
      const { classes } = this.props;

      return (
      <div>
          <Typography variant="h3" gutterBottom>
              Manage Reviewers
          </Typography>
        <div className='row'>
            <div className='columnLeft'>
                <Card className={classes.card}>
                    <Typography variant="h5" gutterBottom className={classes.headertitle}>
                        Reviewers
                    </Typography>
                    <CardContent>
                        <AddedReviewers/>
                    </CardContent>

                </Card>
            </div>
            <div className='columnRight'>
                <Card className={classes.card}>
                    <Typography variant="h5" gutterBottom className={classes.headertitle}>
                        Search for Canvas users
                    </Typography>
                    <CardContent>
                        <AddCanvasUsers/>
                    </CardContent>

                </Card>
            </div>
        </div>
      </div>
    )
  }
}

export default withStyles(styles)(withRoles([ROLES.COORDINATOR, ROLES.ADMIN, ROLES.REVIEWER, ROLES.DEPARTMENTCOORDINATOR])(ManageReviewers));
